export default __webpack_public_path__ + "static/media/fashion.9af592c3.PNG";